<div class="detalle-item-card" [formGroup]="detalleFormGroup" #localDetalleForm="ngForm">
	<div class="detalle-item-card__index">{{ detalleNumero }}</div>
	<div class="detalle-item-card__body">
		<div class="detalle-item-card__fields">
			<div class="detalle-item-card__row">
				<div class="detalle-field detalle-field--code">
					<label class="detalle-field__label" for="codigo-{{ detalleNumero }}">Código</label>
					<input id="codigo-{{ detalleNumero }}" type="text" class="form-control" formControlName="codigo" />
					<div *ngIf="localDetalleForm.touched && detalleFormGroup.controls.codigo.invalid" class="text-danger">
						<div *ngIf="detalleFormGroup.controls.codigo.errors?.required">Campo Requerido</div>
					</div>
				</div>

				<div class="detalle-field detalle-field--name">
					<label class="detalle-field__label" for="nombreItem-{{ detalleNumero }}">Nombre</label>
					<input
						id="nombreItem-{{ detalleNumero }}"
						type="text"
						class="form-control"
						formControlName="nombreItem"
						placeholder="Nombre del Producto"
						(blur)="onSubmit()"
						[ngClass]="{
							'is-invalid': detalleFormGroup.controls.nombreItem.invalid && detalleFormGroup.controls.nombreItem.touched
						}" />
				</div>

				<div class="detalle-field detalle-field--qty">
					<label class="detalle-field__label" for="cantidad-{{ detalleNumero }}">Cant.</label>
					<input id="cantidad-{{ detalleNumero }}" type="number" class="form-control" min="0.1" formControlName="cantidad" (blur)="onSubmit()" />
					<div *ngIf="localDetalleForm.touched && detalleFormGroup.controls.cantidad.invalid" class="text-danger">
						<div *ngIf="detalleFormGroup.controls.cantidad.errors?.required">Campo Requerido</div>
						<div *ngIf="detalleFormGroup.controls.cantidad.errors?.PositiveNumber">Número debe ser positivo</div>
					</div>
				</div>

				<div class="detalle-field detalle-field--price">
					<label class="detalle-field__label" for="precioUnitario-{{ detalleNumero }}">Precio</label>
					<input
						id="precioUnitario-{{ detalleNumero }}"
						type="text" inputmode="decimal" appPrecioMiles
						class="form-control"
						min="0"
						formControlName="precioUnitario"
						(blur)="onSubmit()"
						[ngClass]="{
							'is-invalid': detalleFormGroup.controls.precioUnitario.invalid && detalleFormGroup.controls.precioUnitario.touched
						}" />
					<div class="clp-equivalent text-right mt-1" *ngIf="opciones.tipoMoneda != 'CLP'">CLP {{ this.subPrice | number : "1.0-3" : "es" }}</div>
					<div class="text-danger" *ngIf="detalleFormGroup.controls.precioUnitario.touched && detalleFormGroup.controls.precioUnitario.errors?.precioFormato">Use puntos para miles y coma para decimales.</div>
				</div>

				<div class="detalle-field detalle-field--checkbox" *ngIf="!hideExentoColumn">
					<label class="detalle-field__label" for="exento-{{ detalleNumero }}">Exento</label>
					<div class="custom-control custom-checkbox">
						<input
							type="checkbox"
							class="custom-control-input"
							id="exento-{{ detalleNumero }}"
							formControlName="exento"
							(change)="onExentoChange($event)"
							[disabled]="currentProduct?.impuestos?.length > 0 || selectedTaxes.length > 0"
							[ngClass]="{ 'disabled-opacity': isExentoDisabled }"
							[ngbTooltip]="getExentoTooltipMessage()" />
						<label class="custom-control-label" for="exento-{{ detalleNumero }}" aria-hidden="true"></label>
					</div>
				</div>

				<div class="detalle-field detalle-field--subtotal">
					<label class="detalle-field__label">
						Subtotal
						<fa-icon *ngIf="(currentProduct?.impuestos?.length > 0 || selectedTaxes.length > 0) && currentInvoiceType != InvoiceType.FacturaExportacion" icon="exclamation-triangle" class="fa-sm text-warning ml-1" [ngbTooltip]="list"></fa-icon>
					</label>
					<ng-container *ngIf="opciones.tipoMoneda != 'CLP'; else subtotalClp">
						<input type="text" class="form-control detalle-field__subtotal-input" readonly tabindex="-1" [value]="totalForeign | number : '1.0-2' : 'es'" />
						<div class="clp-equivalent text-right mt-1">CLP {{ detalleDte.total | number : "1.0-2" : "es" }}</div>
					</ng-container>
					<ng-template #subtotalClp>
						<input type="text" class="form-control detalle-field__subtotal-input" readonly tabindex="-1" [value]="detalleDte.total | number : '1.0-2' : 'es'" />
					</ng-template>
				</div>

				<div class="detalle-field detalle-field--delete">
					<label class="detalle-field__label detalle-field__label--spacer">&nbsp;</label>
					<button type="button" class="btn btn-sm btn-light-danger btn_delete" (click)="deleteItem()" title="Eliminar línea">
						<i class="flaticon-delete"></i>
					</button>
				</div>
			</div>


		</div>
	</div>

	<details class="detalle-item-card__extra detalle-adicionales" *ngIf="showingDetails" [open]="adicionalesAbiertos" (toggle)="adicionalesAbiertos = $any($event.target).open">
		<summary class="detalle-adicionales__encabezado">
			<span class="detalle-adicionales__flecha" aria-hidden="true"></span>
			<span>Descripción, descuentos y datos adicionales</span>
		</summary>

		<div class="detalle-item-card__grid mt-3">
			<div class="detalle-field detalle-field--full">
				<label class="detalle-field__label" for="descripcion-{{ detalleNumero }}">Descripción</label>
				<textarea id="descripcion-{{ detalleNumero }}" class="form-control" formControlName="descripcion" (blur)="onSubmit()" rows="2"></textarea>
				<div *ngIf="localDetalleForm.touched && detalleFormGroup.controls.descripcion.invalid" class="text-danger">
					<div *ngIf="detalleFormGroup.controls.descripcion.errors?.required">Campo Requerido</div>
				</div>
			</div>

			<div class="detalle-field detalle-field--full" *ngIf="currentInvoiceType == InvoiceType.FacturaCompra">
				<div class="detalle-field detalle-field--retencion-block">
					<div class="custom-control custom-checkbox mb-2">
						<input type="checkbox" class="custom-control-input" id="haveRetencion-{{ detalleNumero }}" formControlName="haveRetencion" ngbTooltip="Indicar porcentaje de retención" (change)="changeRetencionInput($event)" />
						<label class="custom-control-label" for="haveRetencion-{{ detalleNumero }}">Retiene</label>
					</div>
					<div *ngIf="showRetencionPercent">
						<input type="number" min="0" max="100" class="form-control mb-2" placeholder="% retención" formControlName="retencionPorcentaje" (blur)="onSubmit()" />
						<ng-select formControlName="retencionTipo" [items]="retencionesSource" [selectOnTab]="true" bindLabel="nombre" placeholder="Seleccione retención" (change)="getRetencionChanges($event)"></ng-select>
						<div *ngIf="localDetalleForm.touched && detalleFormGroup.controls.retencionTipo.invalid" class="text-danger">
							<div *ngIf="detalleFormGroup.controls.retencionTipo.errors?.required" class="unbreakable-words">Campo requerido</div>
						</div>
					</div>
				</div>
			</div>
			<div class="detalle-item-card__additional-row" [class.detalle-item-card__additional-row--without-rebaja]="currentInvoiceType != InvoiceType.Factura">
				<div class="detalle-field detalle-field--discount">
					<label class="detalle-field__label" for="descuentoRecargo-{{ detalleNumero }}" ngbTooltip="Valores Negativos indican descuentos y positivos indican recargos">Desc./Rec.</label>
					<input id="descuentoRecargo-{{ detalleNumero }}" type="number" class="form-control" formControlName="descuentoRecargo" (blur)="onSubmit()" />
					<div class="clp-equivalent text-right mt-1" *ngIf="opciones.tipoMoneda != 'CLP'">CLP {{ this.subDiscount | number : "1.0-2" : "es" }}</div>
					<div *ngIf="localDetalleForm.touched && detalleFormGroup.controls.descuentoRecargo.invalid" class="text-danger">
						<div *ngIf="detalleFormGroup.controls.descuentoRecargo.errors?.required">Campo Requerido</div>
					</div>
				</div>

				<div class="detalle-field detalle-field--rebaja" *ngIf="currentInvoiceType == InvoiceType.Factura">
					<label class="detalle-field__label" ngbTooltip="Rebaja por avalúo fiscal.">Rebaja Avalúo</label>
					<input type="number" class="form-control" formControlName="rebajaAvaluo" (blur)="onSubmit()" [min]="0" />
				</div>

				<div class="detalle-field--code-pair" role="group" aria-label="Código adicional del ítem">
					<div class="detalle-field detalle-field--code-type">
						<label class="detalle-field__label" for="tipoCodigo-{{ detalleNumero }}">Tipo Código</label>
						<input id="tipoCodigo-{{ detalleNumero }}" type="text" class="form-control detalle-field__code-input" formControlName="tpoCodigo" (blur)="onSubmit()" maxlength="10" ngbTooltip="máximo 10 caracteres" />
						<div *ngIf="detalleFormGroup.controls.tpoCodigo.invalid && detalleFormGroup.controls.tpoCodigo.touched" class="text-danger">
							<div *ngIf="detalleFormGroup.controls.tpoCodigo.errors?.maxlength">Máximo 10 caracteres</div>
						</div>
					</div>

					<div class="detalle-field detalle-field--code-value">
						<label class="detalle-field__label text-nowrap" for="valorCodigo-{{ detalleNumero }}">Valor Código</label>
						<input id="valorCodigo-{{ detalleNumero }}" type="text" class="form-control detalle-field__code-input" formControlName="vlrCodigo" (blur)="onSubmit()" maxlength="35" ngbTooltip="máximo 35 caracteres" />
						<div *ngIf="detalleFormGroup.controls.vlrCodigo.invalid && detalleFormGroup.controls.vlrCodigo.touched" class="text-danger">
							<div *ngIf="detalleFormGroup.controls.vlrCodigo.errors?.maxlength">Máximo de caracteres: 35</div>
						</div>
					</div>
				</div>

				<div class="detalle-field detalle-field--unit">
					<label class="detalle-field__label" for="unidadMedida-{{ detalleNumero }}">Unidad Medida</label>
					<input id="unidadMedida-{{ detalleNumero }}" type="text" class="form-control" formControlName="unidadMedida" (blur)="onSubmit()" />
					<div *ngIf="localDetalleForm.touched && detalleFormGroup.controls.unidadMedida.invalid" class="text-danger">
						<div *ngIf="detalleFormGroup.controls.unidadMedida.errors?.required">Campo Requerido</div>
					</div>
				</div>

				<div class="detalle-field detalle-field--action" *ngIf="currentInvoiceType != InvoiceType.FacturaExportacion && currentInvoiceType != InvoiceType.FacturaCompra">
					<label class="detalle-field__label detalle-field__label--spacer" aria-hidden="true">Acciones</label>
					<button type="button" class="btn btn-sm btn-light-primary detalle-field__impuestos-btn" [ngbTooltip]="getTaxTooltipMessage()" [ngClass]="{ 'disabled-opacity': isTaxButtonDisabled }" (click)="isTaxButtonDisabled ? null : openTaxModal(taxModal)">
						<i class="fa-solid fa-circle-plus"></i>
						Impuestos
					</button>
				</div>
			</div>

			<div class="detalle-field detalle-field--full" *ngIf="showInExport">
				<label class="detalle-field__label font-weight-bold">Bulto Asociado</label>
				<ng-select [items]="exportPackages" notFoundText="Sin bultos declarados" bindLabel="localIndex" (change)="setDetailFromPackage($event)"></ng-select>
			</div>
		</div>
	</details>

</div>
<ng-template #list>
	<div class="d-flex flex-column">
		<b class="text-danger" *ngIf="opciones.tipoMoneda == 'USD' && currentInvoiceType == InvoiceType.FacturaExportacion"> No considerado </b>
		<b>Impuestos</b>

		<!-- Impuestos del Producto -->
		<span *ngIf="currentProduct?.impuestos?.length > 0">
			<span *ngFor="let tax of currentProduct.impuestos"> • {{ tax.nombre }}, {{ tax.valor }} % </span>
		</span>

		<!-- Impuestos Adicionales -->
		<span *ngIf="taxesSource?.length > 0">
			{{ getTaxTooltip() }}
		</span>
	</div>
</ng-template>

<!-- Modal para seleccionar impuestos -->
<ng-template #taxModal let-modal>
	<div class="modal-header">
		<div>
			<h5 class="modal-title">Seleccionar Impuestos</h5>
			<div *ngIf="currentProduct?.impuestos?.length === 1 && currentInvoiceType != InvoiceType.FacturaCompra" style="background-color: transparent; color: #0000006c; border: none">
				<!--Colocar el nombre del impuesto
                {{ currentProduct?.impuestos[0]?.nombre }} ya está aplicado a este producto.-->
				Este producto ya tiene 1 impuesto; solo puedes añadir 1 más.
			</div>
			<div *ngIf="!currentProduct?.impuestos?.length && currentInvoiceType != InvoiceType.FacturaCompra" style="background-color: transparent; color: #0000006c; border: none">Puedes agregar hasta 2 impuestos.</div>
		</div>
		<button type="button" class="close" (click)="modal.dismiss('Cross click')">×</button>
	</div>

	<div class="modal-body">
		<div *ngFor="let tax of taxesSource" class="form-check">
			<input type="checkbox" [(ngModel)]="tax.selected" [disabled]="(!tax.selected && isTaxSelected()) || selectImpuestoTrue(tax)" class="form-check-input" id="tax-{{ tax.impuestoId }}" />
			<label class="form-check-label" for="tax-{{ tax.impuestoId }}">
				{{ tax.nombre }} - ({{ tax.valor }}%)
				<span *ngIf="selectImpuestoTrue(tax)"> (Aplicado) </span>
			</label>
		</div>
	</div>

	<div class="modal-footer">
		<button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancelar</button>
		<button type="button" class="btn btn-primary" (click)="applyTaxChanges(); modal.close()">Guardar</button>
	</div>
</ng-template>
